const SERVER_IP_CONFIG_PATH = 'noLogins/users/userAccountsApi/queryServerIpConfigPage'
const CHECK_SERVER_ACCESS_PATH = 'noLogins/users/userAccountsApi/checkServerAccessPermission'
const EDIT_ACCESS_APPLY_PATH = 'noLogins/users/userAccountsApi/editAccessApplyRecord'

/**
 * 地址栏 /#/ 前面的部分；若包含 /web 则去掉
 */
export function getLocationBaseBeforeHash() {
  const href = window.location.href
  const hashIndex = href.indexOf('/#/')
  let base
  if (hashIndex >= 0) {
    base = href.substring(0, hashIndex)
  } else {
    const { origin, pathname } = window.location
    base = origin + pathname.replace(/\/$/, '')
  }
  if (base.includes('/web')) {
    base = base.replace(/\/web\/?$/, '')
  }
  return base.replace(/\/$/, '')
}

/**
 * 打包后接口 baseURL：地址栏 /#/ 前部分（去掉 /web）+ htDeepRedWsPlatform/api/
 */
export function getProductionApiBaseUrl() {
  return `${getLocationBaseBeforeHash()}/htDeepRedWsPlatform/api/`
}

/**
 * 固定走 www.silkmiles.com 的接口（打包后）
 * 协议 http/https 随当前地址栏
 */
function buildSilkmilesFixedApiUrl(apiPath) {
  if (process.env.NODE_ENV === 'development') {
    return apiPath
  }
  const protocol = window.location.protocol
  return `${protocol}//www.silkmiles.com/htDeepRedWsPlatform/api/${apiPath}`
}

/**
 * 地址栏 /#/ 前面的穿透地址（不去除 /web，用于与服务器配置匹配）
 */
export function getTunnelAddress() {
  const href = window.location.href
  const hashIndex = href.indexOf('/#/')
  if (hashIndex >= 0) {
    return href.substring(0, hashIndex)
  }
  const { origin, pathname } = window.location
  return origin + pathname.replace(/\/$/, '')
}

/**
 * 远程登录服务器列表接口地址（固定访问 www.silkmiles.com）
 */
export function getServerIpConfigApiUrl() {
  return buildSilkmilesFixedApiUrl(SERVER_IP_CONFIG_PATH)
}

/**
 * 服务器访问权限校验接口地址（固定访问 www.silkmiles.com）
 */
export function getCheckServerAccessPermissionApiUrl() {
  return buildSilkmilesFixedApiUrl(CHECK_SERVER_ACCESS_PATH)
}

/**
 * 申请访问记录接口地址（固定访问 www.silkmiles.com）
 */
export function getEditAccessApplyRecordApiUrl() {
  return buildSilkmilesFixedApiUrl(EDIT_ACCESS_APPLY_PATH)
}


// WEBPACK FOOTER //
// ./src/utils/apiUrl.js